import * as Preact from "preact"

const dom = document.getElementById("preact")

import View from "@frog/source/views/Mount.view.js"

let view = undefined

export default function() {
    view = Preact.render(Preact.h(View), dom, view)
}
